<template>
  <tr class="overflow-visible flex" :class="tableBackground">

    <td class="text-sm relative"  :style="tableForGeneral ? 'width:5%':'width:10%'">
      <div class="flex">
      <!-- team position -->
      <div v-if="tableForGeneral" class="w-auto ml-1 text-center flex">
        <div class="min-w-5">{{tableItem.position}}</div>
      </div>
      <p v-else class="w-6 ml-4 text-center" :class="{'mr-auto':!teamIsChampion}">{{tableItem.position}}</p>
      <div class="relative pl-8 w-full" v-if="teamIsChampion">
      <!-- trophy icon -->
      <div class="relative">
        <img @mouseover="championsPrompt = true"
             @mouseleave="championsPrompt = false"
             :src="require(`@/assets/icons/${pageType==='tuts'?'crown-icon':'trophy'}.svg`)"
             alt="">
      <!-- prompt -->
      <div v-if="championsPrompt" class="champions-prompt" v-html="popoverText"></div>
      </div>

      </div>

      <!-- span to fix position for team does not have trophy -->
          <p v-if="!teamIsChampion && ratingTableType !== 'general' " class="mr-4 w-full" style="height:16px"></p>
      </div>
      </td>

       <td v-if="tableForGeneral" class="text-sm relative" style="width: 5%;" :class="{'icon' : tableItem.rang !== 'Без ранга'}">

          <div v-if="tableItem.rang !== 'Без ранга'" class="flex self-center" >
           <img :src="require(`@/assets/icons/${tableItem.rang}.svg`)"
                 alt="rank-icons"
                 @mouseover="rangPrompt = true"
                 @mouseleave="rangPrompt = false">
          </div>
          <div v-if="rangPrompt" class="rang-prompt">Ранг “{{tableItem.rang}}”</div>

        </td>

    <td
      @mousedown="overflowTumbler"
      @mouseup="overflowTumbler"
      @mouseout="endOverflow"

      field="canAbs"
      style="width: 30%"
    >
    <p class="text-sm max-w-95% whitespace-normal w-full">{{tableItem.name}}</p>
    </td>


    <td class="text-sm" style="width: 20%">{{tableItem.city}}</td>

    <td class="text-sm" style="width: 15%">{{tableItem.game_count}}</td>

    <td class="text-sm" style="width: 15%">{{tableItem.win_count}}</td>

    <td class="text-sm" style="width: 10%;color: #BD006C;">{{Math.round(tableItem.score_sum * 1e2) / 1e2}}</td>
  </tr>
</template>

<script>
export default {
  name: 'MozgoTableItem',
  props: {
    tableItem: {
      type: Object,
    },
    tabNumber: {
      type: Number,
    },
    ratingTableType: {
      type: String,
    },
    popoverText: {
      type: String,
      default: '<p>Команда-участник<br> Лиги Чемпионов</p>',
    },
    showCrownIcon: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: 'general',
    },
  },
  data() {
    return {
      championsPrompt: false,
      rangPrompt: false,
    };
  },
  computed: {
    teamIsChampion() {
      return this.tableItem.highlighted;
    },
    tableForGeneral() {
      if (this.ratingTableType === 'general') {
        return true;
      }
      return false;
    },
    tableBackground() {
      if (this.teamIsChampion && this.pageType === 'general') {
        return 'champion-general';
      } else if (this.teamIsChampion && this.pageType === 'tuts') {
        return 'champion-tuts';
      }
      return '';
    },
  },
  mounted() {
    // тут проходим по всей строке и выставляем поинтеры
    const elem = this.$el;
    [...elem.children].forEach((element) => {
      if (
        element.scrollWidth > element.clientWidth &&
        element.getAttribute('field') === 'canAbs'
      ) {
        element.classList.toggle('cursor-pointer');
      }
    });
  },
  methods: {
    showResultModal() {
      this.$emit('showResultModal', { id: this.tabNumber });
    },
    overflowTumbler(event) {
      const target = event.target.parentElement;
      const isOverflow = target.scrollWidth > target.clientWidth;
      if (
        target.getAttribute('field') === 'canAbs' &&
        (isOverflow || target.classList.contains('exp'))
      ) {
        if (event.type === 'mouseup' && isOverflow) return;
        target.classList.toggle('truncate');
        target.classList.toggle('absolute');
        target.classList.toggle('border');
        target.classList.toggle('bg-white');
        target.classList.toggle('fit_content');
        target.classList.toggle('exp');
      }
    },

    endOverflow(event) {
      const target = event.target.parentElement;
      if (
        target.getAttribute('field') === 'canAbs' &&
        target.classList.contains('exp')
      ) {
        target.classList.toggle('truncate');
        target.classList.toggle('absolute');
        target.classList.toggle('border');
        target.classList.toggle('bg-white');
        target.classList.toggle('fit_content');
        target.classList.toggle('exp');
      }
    },

    isSearched(field) {
      if (!this.$route.query.like) return false;
      const fieldNamesArray = field.split('.');
      const rootObj = this.team;
      const lastObj = fieldNamesArray.reduce(
        (acc, localField) => acc[localField],
        rootObj,
      );
      console.dir(lastObj);
      if (!lastObj) return false;

      return !!lastObj
        .toLowerCase()
        .includes(this.$route.query.like.toLowerCase());
    },
  },
};
</script>

<style scoped>
tr {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.champion-general{
  background: rgba(255, 206, 66, 0.2);
}
.champion-tuts{
  background: #FFE9DA;
}

td {
  @apply text-left font-sans text-sm;
}

.fit_content {
  max-width: fit-content !important;
}
td {
  /*padding: 7.5px 0;*/
  height: 35px;
  display: flex;
  align-items: center;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  border-bottom: 1px solid #dadada;
  color: #333333;
}
.champions-prompt{
  width: 168px;
  height: 50px;
  padding: 0.5rem 1rem;
  background:#ffffff;
  border: 0.5px solid #DADADA;
  box-sizing: border-box;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
  position: absolute;
  top: 1.4rem;
  left: 0rem;
  z-index: 100;
}
.rang-prompt{
  height: 31px;
  padding: 0.5rem 1rem;
  background:#ffffff;
  border: 0.5px solid #DADADA;
  box-sizing: border-box;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
  position: absolute;
  top: 2rem;
  left: 1.5rem;
  z-index: 100;
}
</style>
